// https://github.com/vercel/swr/tree/master/examples/infinite-scroll
import { useRef, useEffect } from 'react'
import { useSWRInfinite } from 'swr'
import { getUrl } from 'utils/api'
import NoResults from 'components/no-results/no-results'
import Grid from 'components/grid/grid'
import useOnScreen from 'utils/hooks/useOnScreen'
import LoaderInline from 'components/loader-inline/loader-inline'

export default function Infinite({
    endpoint,
    component,
    holder,
    onDataChange,
    cols,
    perLine,
    query,
    props,
    auth = true
}) {
    const ref = useRef()
    const isVisible = useOnScreen(ref)
    const HolderComponent = holder || Grid

    const getKey = (pageIndex, prevData) => {
        if (prevData && !prevData.length) return null
        return getUrl(`${endpoint}/${pageIndex + 1}`, query, auth)
    }

    const { data, size, setSize, error, isValidating } = useSWRInfinite(getKey)

    const hasError = data && !!data[0].error
    const items = hasError || !data ? [] : [].concat(...data)
    const isLoadingInitialData = !data && !error
    const isLoadingMore = isLoadingInitialData || (size > 0 && data && typeof data[size - 1] === 'undefined')
    const isEmpty = data && data[0].length === 0
    const isReachingEnd = hasError || isEmpty || (data && data[data.length - 1] && data[data.length - 1].length < 10)
    const isRefreshing = isValidating && data && data.length === size

    if (isLoadingMore) {
        console.log('data loading')
    }

    useEffect(() => {
        if (isVisible && !isReachingEnd && !isRefreshing && !isLoadingMore) {
            setSize(size + 1)
        }
    }, [isVisible, isRefreshing, error])

    useEffect(() => {
        if (onDataChange) {
            onDataChange(data)
        }
    }, [data])

    return (
        <>
            {items.length ? (
                <>
                    <HolderComponent cols={cols} items={items} perLine={perLine} props={props} component={component} />
                    {isLoadingMore && <LoaderInline />}
                </>
            ) : isReachingEnd ? (
                <NoResults />
            ) : null}
            <div ref={ref}></div>
        </>
    )
}
